import correctingInterval from 'correcting-interval'

let Animation = {
	animate: null
}

let t = 0
let id = correctingInterval.setCorrectingInterval(function() {
	if (Animation.animate) Animation.animate()
}, 20)

export default Animation
